import { LocationAnalysisEventType } from "src/store/locationAnalysisEvent/types";

export const LOCATION_ANALYSIS_EVENT_LABEL: {
  [key in LocationAnalysisEventType]: string;
} = {
  usa_only: "USA Only",
  international_only: "International Only",
  usa_and_international: "USA and International",
};
